













import Vue from 'vue'
import Component from 'vue-class-component'
import { Mixins } from 'vue-property-decorator'
import { State, Action } from 'vuex-class'
import { availableLocales } from 'bits/locale'

@Component
export default class LocaleSelector extends Mixins() {
  @State currentLocale
  @Action changeLocale
  locales = availableLocales

  emitChange(e: Event): void {
    this.changeLocale(e)
  }
}
